import axios from 'axios';
const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000' });
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('sf_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
API.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401) { localStorage.removeItem('sf_token'); localStorage.removeItem('sf_user'); window.location.href = '/'; }
  return Promise.reject(err);
});
export default API;
